"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var InternalSite_1 = require("../model/InternalSite");

var InternalSiteConverter_1 = require("./InternalSiteConverter");
/**
 * Default implementation of {@link InternalSiteConverter internal site converter}.
 *
 * @author David Uhlíř
 * @author JMe
 */


var InternalSiteConverterImpl =
/*#__PURE__*/
function (_InternalSiteConverte) {
  _inherits(InternalSiteConverterImpl, _InternalSiteConverte);

  function InternalSiteConverterImpl() {
    _classCallCheck(this, InternalSiteConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(InternalSiteConverterImpl).apply(this, arguments));
  }

  _createClass(InternalSiteConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new InternalSite_1.InternalSite(InternalSite_1.InternalSite.schema.id.valueOf(conversions.documentToClassId(source)), InternalSite_1.InternalSite.schema.externalId.valueOfField(source), InternalSite_1.InternalSite.schema.numericId.valueOfField(source), InternalSite_1.InternalSite.schema.name.valueOfField(source), InternalSite_1.InternalSite.schema.address.valueOfField(source), InternalSite_1.InternalSite.schema.companyId.valueOf(conversions.toClassReferenceId(source.companyId)), InternalSite_1.InternalSite.schema.type.valueOfField(source), InternalSite_1.InternalSite.schema.formatId.valueOf(conversions.toClassReferenceId(source.formatId)), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag), InternalSite_1.InternalSite.schema.refExternalId.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        name: source.name,
        externalId: source.externalId,
        numericId: source.numericId,
        address: source.address,
        companyId: conversions.toDocumentReferenceId(source.companyId),
        type: source.type,
        formatId: conversions.toDocumentReferenceId(source.formatId),
        stateFlags: source.stateFlags.serialize(),
        refExternalId: source.refExternalId
      });
      return result;
    }
  }]);

  return InternalSiteConverterImpl;
}(InternalSiteConverter_1.InternalSiteConverter);

exports.InternalSiteConverterImpl = InternalSiteConverterImpl;